module.exports = __webpack_public_path__ + "img/line_355912539010218.d4206cbf.jpg";